/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioVolumeSXIcon16Light } from './MediaAudioVolumeSXIcon16Light';
import { MediaAudioVolumeSXIcon16Regular } from './MediaAudioVolumeSXIcon16Regular';
import { MediaAudioVolumeSXIcon16Solid } from './MediaAudioVolumeSXIcon16Solid';
import { MediaAudioVolumeSXIcon20Light } from './MediaAudioVolumeSXIcon20Light';
import { MediaAudioVolumeSXIcon20Regular } from './MediaAudioVolumeSXIcon20Regular';
import { MediaAudioVolumeSXIcon20Solid } from './MediaAudioVolumeSXIcon20Solid';
import { MediaAudioVolumeSXIcon24Regular } from './MediaAudioVolumeSXIcon24Regular';
import { MediaAudioVolumeSXIcon24Solid } from './MediaAudioVolumeSXIcon24Solid';
import { MediaAudioVolumeSXIcon32Regular } from './MediaAudioVolumeSXIcon32Regular';
import { MediaAudioVolumeSXIcon64Regular } from './MediaAudioVolumeSXIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioVolumeSXIcon16Light,
        regular: MediaAudioVolumeSXIcon16Regular,
        solid: MediaAudioVolumeSXIcon16Solid,
    },
    20: {
        light: MediaAudioVolumeSXIcon20Light,
        regular: MediaAudioVolumeSXIcon20Regular,
        solid: MediaAudioVolumeSXIcon20Solid,
    },
    24: {
        regular: MediaAudioVolumeSXIcon24Regular,
        solid: MediaAudioVolumeSXIcon24Solid,
    },
    32: {
        regular: MediaAudioVolumeSXIcon32Regular,
    },
    64: {
        regular: MediaAudioVolumeSXIcon64Regular,
    },
};
export var MediaAudioVolumeSXIcon = forwardRef('MediaAudioVolumeSXIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
